export const useManufacturerStore = defineStore('manufacturer', () => {
  const store = useStore()
  const { filterLoading } = storeToRefs(store)
  const manufacturer = ref()
  const productsData = ref()
  const url = ref<any>({})
  const scrollIndex = ref(0)
  const startPage = ref(1)
  const name = computed(() => {
    const page = productsData.value.page
    const name = manufacturer.value.metaTitle || manufacturer.value.name
    return page > 1 ? `${name} - strona ${page}` : name
  })
  const metaTitle = computed(() => {
    const page = scrollIndex.value ? startPage.value : productsData.value.page
    const metaTitle = manufacturer.value.metaTitle || manufacturer.value.name
    return page > 1 ? `${metaTitle} - strona ${page}` : metaTitle
  })
  const metaDescription = computed(() => {
    const page = scrollIndex.value ? startPage.value : productsData.value.page
    return page > 1 ? `${manufacturer.value.metaDescription} - strona ${page}` : manufacturer.value.metaDescription
  })

  const init = async ({ id, query, url }: { id: string, query: any, url: string }) => {
    const getManufacturer = await useFetch(`/store-api/manufacturer/${id}`, {
      query: {
        url
      }
    })
    manufacturer.value = getManufacturer.data.value
    await loadFilter({ query, url })
  }
  const loadFilter = async ({ query, url }: { query: any, url: string }) => {
    const products = await useFetch('/store-api/product', {
      method: 'POST',
      body: {
        'total-count-mode': 1,
        limit: 36,
        page: query.p || 1,
        filter: [
          {
            type: 'equals',
            field: 'manufacturerId',
            value: manufacturer.value.id
          },
          {
            type: 'equals',
            field: 'product.parentId',
            value: null
          },
          {
            type: 'not',
            operator: 'or',
            queries: [
              {
                type: 'equals',
                field: 'seoUrls.id',
                value: null
              },
              {
                type: 'equals',
                field: 'product.id',
                value: 'b02ec300f88363cac4572b8084bad604'
              }
            ]
          }
        ],
        associations: {
          productReviews: {}
        }
      },
      query: {
        url
      }
    })
    productsData.value = products.data.value
  }

  const load = async ({ type, p, path }: { type: any, p?: number, path: string, }) => {
    url.value.p = undefined
    if (type === 'p') {
      url.value.p = p
    }
    filterLoading.value = true
    await loadFilter({ query: url.value, url: path }).then(async () => {
      await navigateTo({ path, query: url.value })
      filterLoading.value = false
    })
  }

  return { productsData, url, scrollIndex, startPage, name, metaTitle, metaDescription, init, loadFilter, load }
})
